function playVideoInMobile() {
  if ($(window).width() < 799) {
    $('body').on(
      'click',
      '.product__modal-opener--external_video a, product__modal-opener--video a',
      function () {
        const oDOM = $(this).closest('li');
        if (oDOM.length > 0) {
          oDOM.find('deferred-media').show();
          oDOM.find('modal-opener').hide();
          oDOM.find('iframe').get(0).src += `${
            oDOM.find('iframe').get(0).src.indexOf('?') > -1 ? '&' : '?'
          }autoplay=1`;
        }
      },
    );
  }
}

export { playVideoInMobile as default };
